<!-- 管理者ログイン画面-->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
  <!-- ▼ contents -->
  <div id="contents">
    <!-- ▽  -->
    <section id="mainContent">
      <h2><b>《管理者様用》</b>ログイン</h2>
      <p>※管理者用のユーザーID、パスワードを忘れた場合はクロスウェイ(株)へお問い合わせください。</p>
      <section class="login">
        <ul>
          <li><b>ユーザーID</b><input type="text" v-model="loginForm.userId"></li>
          <li><b>パスワード</b><input type="password" v-model="loginForm.password"></li>
          <li class="btnLst"><button class="loginBtn" v-on:click="onLogin">ログイン</button></li>
        </ul>
      </section>
    </section>
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
      <dt slot="modal-header">入力エラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer">
        <a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a>
      </dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.authError.isShow" v-on:close="onAuthErrorModalClose">
      <dt slot="modal-header">認証エラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.authError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer">
        <a href="javascript:void(0)" v-on:click="onAuthErrorModalClose">閉じる</a>
      </dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
      <dt slot="modal-header">システムエラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer">
        <a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a>
      </dd>
    </modalWindow>
    <!-- モーダルWindow E -->
  </div>
</template>

<script>
  import { AdminLogin } from '@/api'
  import { Auth } from '@/api/'
  import * as types from '@/store/mutation-types'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityValidation from '@/components/Utility/UtilitiValidation'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'AdminLogin',
    // 使用コンポーネント
    components: {
      // エラー表示コンポーネント
      'errorMessageBox': ErrorMessageBox,
      // モーダルウィンドウ表示コンポーネント
      'modalWindow': ModalWindow
    },
    // データ
    data() {
      return {
        // 医療機関個別の情報
        irInfo: {
          irnm : ''
        },
        // ログインフォーム
        loginForm: {
          userId: '',
          password: ''
        },
        // モーダルウィンドウ
        modal: {
          validationError: {
            messages: [],
            isShow: false
          },
          authError: {
            messages: [
              '認証エラーです。',
              'ユーザーIDとパスワードをもう一度ご確認ください。'
            ],
            isShow: false
          },
          systemError: {
						messages: [
						  'システムエラーです。',
						  '内容をもう一度ご確認ください。'
						],
            isShow: false
          }
        }
      }
    },
    // ライフサイクルフック: created
    created: function () {

      UtilityConsoleLog.consoleLog('AdminLogin::firstDisplay created')

      this.firstDisplay()

      UtilityConsoleLog.consoleLog('AdminLogin::firstDisplay created')
    },
    methods: {

      // 表示系--------------------------------------------------S
      // 初期表示
      firstDisplay: function () {
        UtilityConsoleLog.consoleLog('AdminLogin::firstDisplay Start')

        // ストアの状況に関わらず
        // ログアウト処理を行う
        this.$store.commit(types.ADMIN_AUTH_LOGOUT)

        UtilityConsoleLog.consoleLog('AdminLogin::firstDisplay End')
      },
      // 表示系--------------------------------------------------E
      // イベント系--------------------------------------------------S
      // ログインボタン押下時
      onLogin: function () {

        UtilityConsoleLog.consoleLog('AdminLogin::onLogin Start')

        // 入力チェック
        var errorMessagesList = this.validationOnLogin()

        if (errorMessagesList.length > 0) {
          this.onValidationErrorModalOpen(errorMessagesList)
          UtilityConsoleLog.consoleLog('AdminLogin::onLogin End')
          return;
        }

        // ログイン処理を行う
        this.apiLogin()

        UtilityConsoleLog.consoleLog('AdminLogin::onLogin End')
      },
      // イベント系--------------------------------------------------E
      // 通信系--------------------------------------------------S
      // ログイン時通信処理
      apiLogin: function () {
        UtilityConsoleLog.consoleLog('AdminLogin::apiLogin Start')
        // サーバーが正常に稼働しているかを確認する
        AdminLogin.GetAliveServer()
          .then(() => {
            // ログイン処理
            Auth.login({
              userId: this.loginForm.userId,
              password: this.loginForm.password
            }).then(({ responce }) => {

              this.$store.commit(
                types.ADMIN_AUTH_LOGIN,
                {
                  userId: responce.data.userId,
                  token: responce.data.access_token
                }
              )
              // ユーザー情報を取得
              AdminLogin.GetUserInfo({
                ircd: this.$store.state.auth.ircd,
                token: this.$store.state.auth.token
              }).then(({ responce }) => {

                if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

                  this.$store.commit(
                    types.ADMIN_USERINFO_SETUSERINFO,
                    {
                      irnm: responce.data.irnm
                    })
                  this.$router.push("/AdminReserveStatusCheck")
                } else {
                  // システムエラー時
                  this.onSystemErrorModalOpen()
                }
              }).catch(() => {
                // システムエラー時
                this.onSystemErrorModalOpen()
              })
            }).catch(() => {
              this.onAuthErrorModalOpen()
            })
          }).catch(() => {
            this.onSystemErrorModalOpen()
          }).finally(() => {
	          UtilityConsoleLog.consoleLog('AdminLogin::apiLogin End')
	        })
      },
      // その他--------------------------------------------------S
      // ログインボタン押下時
      validationOnLogin: function() {

        UtilityConsoleLog.consoleLog('AdminLogin::validationOnLogin Start')

        // エラーメッセージリスト
        var errorMessagesList = []

        var tempErrorMessage = []

        // ユーザーID
        tempErrorMessage = this.validationUserID()
        tempErrorMessage.forEach((item)=>{
          errorMessagesList.push(item)
        })

        // パスワード
        tempErrorMessage = this.validationPassword()
        tempErrorMessage.forEach((item)=>{
          errorMessagesList.push(item)
        })

        UtilityConsoleLog.consoleLog('AdminLogin::validationOnLogin End')

        return errorMessagesList
      },
      // ユーザーID入力チェック
      validationUserID: function() {

        UtilityConsoleLog.consoleLog('AdminLogin::validationLoginID Start')

        var propertyNameUserID = 'ユーザーID'
        var lengthUserID  = 8

        // エラーメッセージリスト
        var errorMessagesList = []

        if (UtilityValidation.checkStrIsNull(this.loginForm.userId)) { // Nullチェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsNull(
              propertyNameUserID))
        } else if (UtilityValidation.checkStrIsKaraMoji(this.loginForm.userId)) { // 空文字チェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
              propertyNameUserID))
        } else if (!UtilityValidation.checkStrLength(this.loginForm.userId, lengthUserID)) { // 桁数チェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrLength(
              propertyNameUserID, String(lengthUserID)))
        } else if (!UtilityValidation.checkStrHalfWidthAlphaNumeric(this.loginForm.userId)) { // 半角英数チェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrHalfWidthAlphaNumeric(
              propertyNameUserID))
        }

        UtilityConsoleLog.consoleLog('AdminLogin::validationLoginID End')

        return errorMessagesList
      },
      // パスワード入力チェック
      validationPassword: function() {

        UtilityConsoleLog.consoleLog('AdminLogin::validationPassword Start')

        var propertyNamePassword = 'パスワード'
        var lengthMaxPassword  = 65

        // エラーメッセージリスト
        var errorMessagesList = []

        if (UtilityValidation.checkStrIsNull(this.loginForm.password)) { // Nullチェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsNull(
              propertyNamePassword))
        } else if (UtilityValidation.checkStrIsKaraMoji(this.loginForm.password)) { // 空文字チェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrIsKaraMoji(
              propertyNamePassword))
        } else if (!UtilityValidation.checkStrMaxLength(this.loginForm.password, lengthMaxPassword)) { // 桁数チェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrMaxLength(
              propertyNamePassword, String(lengthMaxPassword)))
        } else if (!UtilityValidation.checkStrPassword(this.loginForm.password)) { // 半角英数チェック
          errorMessagesList.push(
            UtilityValidation.getErrorMessageCheckStrPassword(
              propertyNamePassword))
        }

        UtilityConsoleLog.consoleLog('AdminLogin::validationPassword End')

        return errorMessagesList
      },
      // バリデーションエラーモーダルとしてエラーモーダルを開く
      onValidationErrorModalOpen: function (errorMessages) {

        UtilityConsoleLog.consoleLog('AdminLogin::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

        this.modal.validationError.messages = tempMessages
        this.modalOpen('validationError')

        UtilityConsoleLog.consoleLog('AdminLogin::onValidationErrorModalOpen End')
      },
      // バリデーションエラーモーダルを閉じる
      onValidationErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('AdminLogin::onValidationErrorModalClose Start')

        this.modal.validationError.messages = []
        this.modalClose('validationError')

        UtilityConsoleLog.consoleLog('AdminLogin::onValidationErrorModalClose End')
      },
      // 認証エラーモーダルとしてエラーモーダルを開く
      onAuthErrorModalOpen: function () {

        UtilityConsoleLog.consoleLog('AdminLogin::onAuthErrorModalOpen Start')

        this.modalOpen('authError')

        UtilityConsoleLog.consoleLog('AdminLogin::onAuthErrorModalOpen End')
      },
      // 認証エラーモーダルとしてエラーモーダルを閉じる
      onAuthErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('AdminLogin::onAuthErrorModalClose Start')

        this.modalClose('authError')

        UtilityConsoleLog.consoleLog('AdminLogin::onAuthErrorModalClose End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {

        UtilityConsoleLog.consoleLog('AdminLogin::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('AdminLogin::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルを閉じる
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('AdminLogin::onSystemErrorModalClose Start')

        this.modalClose('systemError')

        UtilityConsoleLog.consoleLog('AdminLogin::onSystemErrorModalClose End')
      },
      // モーダルウィンドウを開く
      modalOpen: function (modalName) {

        UtilityConsoleLog.consoleLog('AdminLogin::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('AdminLogin::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {

        UtilityConsoleLog.consoleLog('AdminLogin::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('AdminLogin::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
      // その他--------------------------------------------------E
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Admin/Login/AdminLogin.vue